import React, { useEffect, useState, useRef,useContext } from "react";

const Slider = (props) => {

  const currentUrl = new URL(window.location)
  const period = currentUrl.searchParams.get("period")
    ? currentUrl.searchParams.get("period") * 1000
    : 5000;
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderElem = useRef(null);

  const totalSlide =  parseInt(props.totalSlide)
  //console.log(totalSlide)
  useEffect(() => {
    let sliders = sliderElem.current.children;

    let sliderLoop = setInterval((props) => {
    if(!sliders.length || sliders.length === 1)
        return
        //console.log(totalSlide,currentSlide)
  
    if (
        currentSlide ===
        totalSlide - 1 &&
        currentSlide > 0
      ) {
        sliders[currentSlide].style.display = "none";

        sliders[0].style.display = "block";
        setCurrentSlide(0);
      } else {
        
        sliders[currentSlide].style.display = "none";

        sliders[currentSlide + 1].style.display = "block";
        setCurrentSlide(currentSlide + 1);
      }
    }, period);

    return () => {
      clearInterval(sliderLoop);
    };
  }, [currentSlide]);

  return(
      <div ref={sliderElem}>
          {props.children}
      </div>
  )
};

export default Slider
